import { createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'
import DashboardService from '../../../core/service'

export const getSuggestionCompany = createAsyncThunk(
  'dashboard/interested/getSuggestionCompany',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getSuggestionCompany(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)

export const getSuggestionCompanyDetail = createAsyncThunk(
  'dashboard/interested/getSuggestionCompanyDetail',
  async (params, { rejectWithValue }) => {
    try {
      const res = await DashboardService.getSuggestionCompanyDetail(params)
      if (res.success) {
        return res.data
      }
      return rejectWithValue({ loading: false })
    } catch (err) {
      if (axios.isCancel(err)) {
        return rejectWithValue({ loading: true })
      }
      return rejectWithValue({ loading: false })
    }
  },
)
